import { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

const sections = [
  {
    icon: "ri-compass-3-line",
    title: "网站定位",
    body:
      "亚洲无码是一个面向 18 岁以上用户的成人影视资料索引站。我们把日本、韩国、中国香港、中国台湾与泰国的作品按题材、地区与年份重新编目，提供作品简介、剧集目录、标签与相关推荐，方便你在决定观看前先了解一部作品的基本资料。本站不提供在线播放、下载、支付与会员服务，所有页面内容均为文字与图片资料。",
  },
  {
    icon: "ri-stack-line",
    title: "内容与编目方式",
    body:
      "全站目前收录 50 部作品资料，划分为剧情片、伦理片、都市情缘、古装情色、悬疑情欲五个分类，并设有 3 个主题专题合集。每部作品包含标题、制作地区、上映年份、剧集数量、导演与出品信息。剧集目录仅为文字索引，用于说明作品结构，点击后可查看单集简介，不涉及任何播放行为。",
  },
  {
    icon: "ri-shield-check-line",
    title: "18+ 访问须知",
    body:
      "本站内容仅限年满 18 周岁（或所在国家、地区法定成年年龄）的用户访问。进入本站即表示你确认自己已达到法定年龄，并自愿浏览成人向的影视资料。如果你未满 18 岁，或所在地法律不允许访问此类内容，请立即离开本站。建议在私密环境下浏览，避免在公共场合或共享设备上打开。",
  },
  {
    icon: "ri-file-warning-line",
    title: "免责声明",
    body:
      "本站为演示性质的资料索引站，站内作品名称、简介、人物、导演与出品方信息均为虚构内容，不对应任何真实作品或真实人物。站内不存储、不托管、不分发任何视频文件，不提供播放链接、下载地址或第三方跳转。若你发现页面内容存在权利争议，可通过下方邮箱联系我们，我们会尽快核实并处理。",
  },
];

export default function About() {
  useEffect(() => {
    document.title = "关于我们 - 亚洲无码高清成人影视";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "了解亚洲无码网站的定位、内容编目方式、18 岁以上访问须知、免责声明与联系方式。本站仅提供成人影视作品资料索引，不含播放与下载。",
      );
    }
  }, []);

  return (
    <SiteLayout>
      <section className="relative overflow-hidden border-b border-background-300/50 bg-background-100">
        <div className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full bg-primary-500/10 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-32 left-1/4 h-64 w-64 rounded-full bg-accent-500/10 blur-3xl" />
        <div className="relative mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-16">
          <nav className="flex flex-wrap items-center gap-1.5 text-[11px] text-foreground-600">
            <Link to="/" className="cursor-pointer whitespace-nowrap transition hover:text-primary-300">
              首页
            </Link>
            <i className="ri-arrow-right-s-line text-foreground-700" />
            <span className="text-foreground-300">关于我们</span>
          </nav>
          <p className="mt-5 font-heading text-[10px] uppercase tracking-[0.3em] text-primary-500">About Us</p>
          <h1 className="mt-2 max-w-3xl font-heading text-3xl font-bold leading-tight text-foreground-50 md:text-[40px]">
            关于亚洲无码 · 高清亚洲成人影视内容平台
          </h1>
          <p className="mt-4 max-w-3xl text-[13px] leading-[1.9] text-foreground-400 md:text-sm">
            我们相信「先了解，再选择」。亚洲无码以资料库的方式整理亚洲成人影视作品信息，用清晰的分类、统一的字段与可检索的标签，替代杂乱无章的索引列表。这里没有播放按钮，只有值得被认真阅读的作品档案。
          </p>

          <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
            {[
              { label: "收录作品", value: "50", unit: "部" },
              { label: "内容分类", value: "5", unit: "类" },
              { label: "精选专题", value: "3", unit: "个" },
              { label: "覆盖地区", value: "5", unit: "地" },
            ].map((stat) => (
              <div key={stat.label} className="rounded-lg border border-background-300/60 bg-background-50 p-4">
                <p className="font-heading text-2xl font-bold text-primary-400 md:text-3xl">
                  {stat.value}
                  <span className="ml-1 text-[11px] font-normal text-foreground-600">{stat.unit}</span>
                </p>
                <p className="mt-1 text-[11px] text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="mx-auto grid w-full max-w-[1440px] grid-cols-1 gap-6 px-4 py-10 md:px-8 md:py-14 lg:grid-cols-[1fr_320px]">
        <div className="min-w-0 space-y-4">
          {sections.map((section, index) => (
            <section
              key={section.title}
              className="rounded-lg border border-background-300/50 bg-background-100 p-5 md:p-6"
            >
              <div className="flex items-start gap-3">
                <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-background-200 text-primary-400">
                  <i className={`${section.icon} text-lg`} />
                </span>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-heading text-[10px] text-foreground-700">
                      0{index + 1}
                    </span>
                    <h2 className="font-heading text-base font-bold text-foreground-50 md:text-lg">
                      {section.title}
                    </h2>
                  </div>
                  <p className="mt-2 text-[13px] leading-[1.95] text-foreground-400">{section.body}</p>
                </div>
              </div>
            </section>
          ))}

          <section className="rounded-lg border border-accent-700/40 bg-accent-950/30 p-5 md:p-6">
            <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-50 md:text-lg">
              <i className="ri-error-warning-line text-accent-400" />
              内容政策摘要
            </h2>
            <ul className="mt-3 space-y-2">
              {[
                "不提供任何形式的在线播放、下载或第三方播放链接。",
                "不涉及支付、充值、会员登录等高权限功能。",
                "收藏与分享按钮仅作界面演示，不保存个人数据。",
                "站内作品信息均为虚构演示资料，不指向真实作品与真实人物。",
                "如发现页面内容与当地法律法规冲突，请停止访问并联系我们。",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2 text-[12.5px] leading-relaxed text-foreground-400">
                  <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-accent-400" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>
        </div>

        <aside className="space-y-4">
          <div className="rounded-lg border border-background-300/60 bg-background-100 p-5">
            <h2 className="font-heading text-[11px] uppercase tracking-[0.22em] text-foreground-600">
              联系方式
            </h2>
            <p className="mt-3 text-[12.5px] leading-relaxed text-foreground-400">
              内容纠错、权利申诉与合作咨询，请通过邮箱联系。我们通常会在 3 个工作日内回复。
            </p>
            <p className="mt-3 flex items-center gap-2 rounded-md border border-background-300/60 bg-background-50 px-3 py-2.5 text-[12.5px] text-primary-300">
              <i className="ri-mail-line" />
              <span className="break-all">contact@asian-archive.example</span>
            </p>
            <p className="mt-2 text-[10px] leading-relaxed text-foreground-600">
              本站不设在线表单与即时客服，仅接受邮件沟通，请勿在邮件中发送敏感个人信息。
            </p>
          </div>

          <div className="rounded-lg border border-background-300/60 bg-background-100 p-5">
            <h2 className="font-heading text-[11px] uppercase tracking-[0.22em] text-foreground-600">
              快速入口
            </h2>
            <div className="mt-3 space-y-1">
              {[
                { to: "/", label: "首页", icon: "ri-home-4-line" },
                { to: "/category/all", label: "全部作品", icon: "ri-stack-line" },
                { to: "/category/classic", label: "古装情色精选", icon: "ri-moon-line" },
                { to: "/special/midnight-tokyo", label: "深夜东京专题", icon: "ri-gallery-line" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="flex cursor-pointer items-center justify-between rounded-md px-2.5 py-2 text-[12.5px] text-foreground-300 transition hover:bg-background-200 hover:text-primary-300"
                >
                  <span className="flex items-center gap-2">
                    <i className={`${link.icon} text-primary-500`} />
                    {link.label}
                  </span>
                  <i className="ri-arrow-right-s-line text-foreground-600" />
                </Link>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-300/60 bg-gradient-to-b from-background-100 to-background-200 p-5">
            <span className="flex h-9 items-center rounded border border-accent-500/50 px-2.5 font-heading text-[11px] font-bold text-accent-300 w-fit">
              18+
            </span>
            <p className="mt-3 text-[12px] leading-relaxed text-foreground-400">
              本站内容仅面向成年人。请在离开时清除浏览记录，并避免在公共设备上保存页面。
            </p>
            <Link
              to="/"
              className="mt-4 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-[12.5px] font-semibold text-background-950 transition hover:bg-primary-400"
            >
              <i className="ri-arrow-left-line" />
              返回首页
            </Link>
          </div>
        </aside>
      </div>
    </SiteLayout>
  );
}